import { useLang } from "../context/LanguageContext";
import { useData } from "../context/DataContext";

function formatDate(iso, lang) {
  const [year, month] = iso.split("-");
  if (lang === "ja") return `${year}年${Number(month)}月`;
  const names = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  return `${names[Number(month) - 1]} ${year}`;
}

export default function News() {
  const { lang, t } = useLang();
  const { news } = useData();
  const recent = news
    .filter((item) => item.display !== false)
    .sort((a, b) => (a.date < b.date ? 1 : -1))
    .slice(0, 5);

  return (
    <section id="news" className="section">
      <div className="section__header">
        <h2 className="section__title">{t.nav.news}</h2>
      </div>

      <ul className="news">
        {recent.map((item) => {
          const body = item[lang];
          const content = item.link ? (
            <a
              href={item.link}
              className="news__link"
              target="_blank"
              rel="noreferrer"
            >
              {body}
              <span aria-hidden="true"> ↗</span>
            </a>
          ) : (
            <span>{body}</span>
          );
          return (
            <li key={item.id} className="news__item">
              <time className="news__date">{formatDate(item.date, lang)}</time>
              <div className="news__body">{content}</div>
            </li>
          );
        })}
      </ul>
    </section>
  );
}
